import { IOrder } from '@checkout/payments';
import { RootState } from '@checkout/state';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { OrderHistoryItem } from '..';
import messages from './../../../i18n/base-en';
import { MessageBox } from './../../presentational';
import * as Styles from './OrderHistoryList.scss';

interface IOwnState {
  limit: number;
}

interface IOwnProps {}

interface IConnectedProps {
  isFetching: boolean;
  orders: IOrder[] | null;
}

interface IConnectetDispatchProps {}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class OrderHistoryList extends React.Component<Props, {}> {

  state: IOwnState = {
    limit: 10,
  };

  loadMore  = () => {
    const limit = this.state.limit + 10;
    this.setState({ limit });
  }

  render() {
    const { isFetching, orders, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <div className={Styles.wrapper}>
        {orders && (
          <Fragment>
            {orders.length === 0 && !isFetching && (
              <MessageBox
                textAlign="center"
                type="info"
                message={formatMessage(messages.membership_no_orders_message)}
              />
            )}
            {orders.slice(0, this.state.limit).map((order: IOrder) => (
              <OrderHistoryItem key={`${order.order}-order`} order={order} />
            ))}
            {this.state.limit <= orders.length && (
              <button className={Styles.loadMore} onClick={this.loadMore}>
                {formatMessage(messages.membership_show_more)}
              </button>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      isFetching: state.checkout.isFetching,
      orders: state.checkout.orders,
    }),
    {}
  )
)(OrderHistoryList);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/OrderHistoryList/OrderHistoryList.tsx